import React, { Component } from 'react';
import { isEmpty } from "lodash"
import { Box, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { orderByDateAsc, orderByDateDsc, orderByDsc } from '../../../store/actions/format';
import Currency from '../../common/Currency';
import { firstDayOfYear } from '../../../utils/statsFunctions';

const t0 = new Date(2022, 0, 1)
class BankBalance extends Component {
    state = { }

    getSoldeStartDate = () => {
        const { PAYMENT_DETAILS, ADVANCES, INCOMES, TRANSFERS, DEBITS, ADVANCE_RETURNS, bank, start_date } = this.props;

        const s0 = bank.bank_solde_2022 || 0
        let soldeStart = 0

        let payments = Object.values(PAYMENT_DETAILS).filter(pay => 
            pay.payment_details_mode !== "ACOMPTE" && 
            pay.payment_details_bank === bank.bank_id &&
            new Date(pay.payment_details_date) >= t0 && 
            new Date(pay.payment_details_date) < start_date
        )

        // let advances = !isEmpty(ADVANCES) ? Object.values(ADVANCES).filter(item => 
        //     item.advance_bank_id === bank.bank_id &&
        //     new Date(item.advance_date) >= t0 && 
        //     new Date(item.advance_date) < start_date ) 
        // : 
        //     []
        let advanceReturns = !isEmpty(ADVANCE_RETURNS) ? Object.values(ADVANCE_RETURNS).filter(item => 
            item.advance_bank_id === bank.bank_id &&
            new Date(item.advance_date) >= t0 && 
            new Date(item.advance_date) < start_date ) 
        : 
            []
        let debits = !isEmpty(DEBITS) ? Object.values(DEBITS).filter(item => 
            item.credit_bank === bank.bank_id &&
            new Date(item.credit_creation_date) >= t0 && 
            new Date(item.credit_creation_date) < start_date ) 
        : 
            []
            
        let incomes = !isEmpty(INCOMES) ? Object.values(INCOMES).filter(item => 
            item.income_bank === bank.bank_id &&
            new Date(item.income_date) >= t0 && 
            new Date(item.income_date) < start_date ) 
        : 
            []

        let trfIn = !isEmpty(TRANSFERS) ? 
            Object.values(TRANSFERS).filter(pay => 
                pay.transfer_bank_dest === bank.bank_id &&
                new Date(pay.transfer_date) >= t0 && new Date(pay.transfer_date) < start_date
            ) : 
            [];
        let trfOut = !isEmpty(TRANSFERS) ? 
            Object.values(TRANSFERS).filter(pay => 
                pay.transfer_bank_src === bank.bank_id &&
                new Date(pay.transfer_date) >= t0 && new Date(pay.transfer_date) < start_date
            ) : 
            [];

        // INS
        incomes.forEach(pay => {
            soldeStart += pay.income_amount
        })
        debits.forEach(pay => {
            soldeStart += pay.credit_amount
        })
        trfIn.forEach(pay => {
            soldeStart += pay.transfer_amount
        })
        advanceReturns.forEach(pay => {
            soldeStart += pay.advance_amount
        })

        // OUTS
        payments.forEach(pay => {
            soldeStart -= pay.payment_amount
        })
        // advances.forEach(pay => {
        //     soldeStart -= pay.advance_amount
        // })
        trfOut.forEach(pay => {
            soldeStart -= pay.transfer_amount
        })

        // console.log('====================================');
        // console.log({soldeStart});
        // console.log('====================================');
        return soldeStart + s0
    }
    formatlist = () => {
        const { PAYMENT_DETAILS, ADVANCE_RETURNS, INCOMES, TRANSFERS, DEBITS, bank, start_date, end_date } = this.props;
        const soldeStart = this.getSoldeStartDate()
        let total = soldeStart
        let totalIn = 0
        let totalOut = 0
        let tmpList = []
        let lists = {}

        let payments = Object.values(PAYMENT_DETAILS).filter(pay => 
            pay.payment_details_mode !== "ACOMPTE" && pay.payment_details_mode !== "COLLAB" && pay.payment_details_bank === bank.bank_id &&
            new Date(pay.payment_details_date) >= start_date && new Date(pay.payment_details_date) <= end_date
        )

        let advanceReturns = !isEmpty(ADVANCE_RETURNS) ? Object.values(ADVANCE_RETURNS).filter(item => item.advance_bank === bank.bank_id &&
            new Date(item.advance_date) >= start_date && new Date(item.advance_date) <= end_date ) : []
        console.log('====================================');
        console.log({ADVANCE_RETURNS, advanceReturns});
        console.log('====================================');
            
        let incomes = !isEmpty(INCOMES) ? Object.values(INCOMES).filter(item => item.income_bank === bank.bank_id &&
            new Date(item.income_date) >= start_date && new Date(item.income_date) <= end_date ) : []
        let debits = !isEmpty(DEBITS) ? Object.values(DEBITS).filter(item => item.credit_bank === bank.bank_id &&
            new Date(item.credit_creation_date) >= start_date && new Date(item.credit_creation_date) <= end_date ) : []

        let trfIn = !isEmpty(TRANSFERS) ? 
            Object.values(TRANSFERS).filter(pay => 
                pay.transfer_bank_dest === bank.bank_id &&
                new Date(pay.transfer_date) >= start_date && new Date(pay.transfer_date) <= end_date
            ) : 
            [];
        let trfOut = !isEmpty(TRANSFERS) ? 
            Object.values(TRANSFERS).filter(pay => 
                pay.transfer_bank_src === bank.bank_id &&
                new Date(pay.transfer_date) >= start_date && new Date(pay.transfer_date) <= end_date
            ) : 
            [];
        // INS
        incomes.forEach(pay => {
            let tmp = {
                id: `in:income:${pay.income_id}`,
                debit: pay.income_amount,
                date: pay.income_date,
                desc: pay.income_desc,
                mode: pay.income_payment_mode,
            }
            tmpList.push(tmp)
            totalIn += pay.income_amount
        })
        debits.forEach(pay => {
            let tmp = {
                id: `in:debit:${pay.credit_id}`,
                debit: pay.credit_amount,
                date: pay.credit_creation_date,
                desc: `Retour sur avance - ${pay.credit_ref}`,
                mode: pay.credit_payment_mode,
            }
            tmpList.push(tmp)
            totalIn += pay.credit_amount
        })
        trfIn.forEach(pay => {
            let tmp = {
                id: `in:transfer:${pay.transfer_id}`,
                debit: pay.transfer_amount,
                date: pay.transfer_date,
                desc: pay.transfer_desc,
                mode: pay.transfer_payment_mode,
            }
            tmpList.push(tmp)
            totalIn += pay.transfer_amount
        })
        advanceReturns.forEach(pay => {
            let tmp = {
                id: `in:advance:${pay.advance_id}`,
                debit: pay.advance_amount,
                date: pay.advance_date,
                desc: pay.advance_ref,
                mode: pay.advance_payment_mode,
            }
            tmpList.push(tmp)
            totalIn += pay.advance_amount
        })
        

        // OUTS
        payments.forEach(pay => {
            let tmp = {
                id: `out:payment:${pay.payment_details_id}`,
                credit: pay.payment_amount,
                date: pay.payment_details_date,
                desc: pay.payment_details_ref,
                mode: pay.payment_details_mode,
            }
            tmpList.push(tmp)
            totalOut += pay.payment_amount
        })

        trfOut.forEach(pay => {
            let tmp = {
                id: `out:transfer:${pay.transfer_id}`,
                credit: pay.transfer_amount,
                date: pay.transfer_date,
                desc: pay.transfer_desc,
                mode: pay.transfer_payment_mode,
            }
            tmpList.push(tmp)
            totalOut += pay.transfer_amount
        })
        if (start_date < t0){
            tmpList.push({
                id: "solde2022",
                date: t0.getTime(),            
                solde: bank.bank_solde_2022 || 0
            })
        }
        tmpList.forEach(item => lists[item.id] = item)
        let tmpListDsc = orderByDateDsc(Object.values(lists))

        // console.log('====================================');
        // console.log({total});
        // console.log('====================================');

        tmpListDsc.forEach((tmp, i) => {
            if(new Date(tmp.date) >= t0 ){
                if (tmp.debit) {
                    tmpListDsc[i].solde = total + tmp.debit   
                    total += tmp.debit
                    // console.log('====================================');
                    // console.log({total, debit : tmp.debit});
                    // console.log('====================================');
                } else if (tmp.credit)  {
                    tmpListDsc[i].solde = total - tmp.credit   
                    total -= tmp.credit
                    // console.log('====================================');
                    // console.log({total, credit : tmp.credit});
                    // console.log('====================================');
                }
            }
        })
        tmpList = tmpListDsc.reverse()
        return {
            tmpList, 
            total,
            totalIn,
            totalOut,
            soldeStart
        }
    }

    displayList = () => {
        let data = this.formatlist()
        data.list = data.tmpList.map( item => (
            item.id === "solde2022" ?
                <TableRow 
                    hover
                    key="solde_start"
                >
                    <TableCell style={{ fontStyle: 'italic', fontSize: '18px', fontWeight: 'bold'}} colSpan={5}>Solde au {t0.toLocaleDateString('fr-FR')}</TableCell>   
                    <TableCell style={{ fontStyle: 'italic', fontSize: '18px', fontWeight: 'bold'}}>
                        <Currency value={item.solde} />
                    </TableCell>                      
                </TableRow>
            :
            <TableRow 
                hover
                key={item.id}
            >
                <TableCell >{new Date(item.date).toLocaleDateString('fr-FR')}</TableCell>
                <TableCell >{item.desc}</TableCell>                     
                <TableCell >{item.mode}</TableCell>                     
                <TableCell><Currency value={item.debit} /></TableCell>                     
                <TableCell><Currency value={item.credit} /></TableCell>                         
                <TableCell style={{ fontStyle: 'italic', fontSize: '12px'}}>
                    <Typography variant="button" color="primary"><Currency value={item.solde} /></Typography>
                </TableCell>                         
            </TableRow>
        )) 

        
        return data
    }
    render() {
        let data = this.displayList()
        console.log('====================================');
        console.log({data});
        console.log('====================================');
        return (
            <Box>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Créé le</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Mode</TableCell>
                            <TableCell>Débit</TableCell>
                            <TableCell>Crédit</TableCell>
                            <TableCell>Solde</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* <TableRow 
                            hover
                            key="solde"
                        >
                            <TableCell style={{ fontStyle: 'italic', fontSize: '18px',fontWeight: 'bold'}} colSpan={4}>Solde</TableCell>   
                            <TableCell style={{ fontStyle: 'italic', fontSize: '18px',fontWeight: 'bold'}}>
                                {data.total >= 0 && <Currency value={data.total } />}
                                </TableCell>                     
                            <TableCell style={{ fontStyle: 'italic', fontSize: '18px',fontWeight: 'bold'}}>
                                {data.total < 0 && <Currency value={data.total * -1} />}
                            </TableCell>                         
                        </TableRow> */}
                        <TableRow 
                            hover
                            key="Totaux"
                        >
                            <TableCell style={{ fontStyle: 'italic', fontSize: '18px',fontWeight: 'bold'}} colSpan={3}>Solde au {new Date(this.props.end_date).toLocaleDateString('fr-FR')}</TableCell>   
                            <TableCell style={{ fontStyle: 'italic', fontSize: '14px',fontWeight: 'bold'}}>
                                <Currency value={data.totalIn } />
                            </TableCell>                     
                            <TableCell style={{ fontStyle: 'italic', fontSize: '14px',fontWeight: 'bold'}}>
                                <Currency value={data.totalOut} />
                            </TableCell>   
                            <TableCell style={{ fontStyle: 'italic', fontSize: '18px',fontWeight: 'bold'}}>
                                <Currency value={data.total} />
                            </TableCell>                       
                        </TableRow>
                        {data.list}
                        {this.props.start_date >= t0 &&
                            <TableRow 
                                hover
                                key="solde_start"
                            >
                                <TableCell style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'bold'}} colSpan={5}>Solde au {new Date(this.props.start_date).toLocaleDateString('fr-FR')}</TableCell>   
                                <TableCell style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'bold'}}>
                                    <Currency value={data.soldeStart} />
                                </TableCell>                      
                            </TableRow>
                        }
                    </TableBody>
                    {/* {size(incomes) > 10 &&
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10, 30]}
                                    colSpan={5}
                                    count={size(incomes)}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onPageChange={this.handleChangePage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    ActionsComponent={Pagination}
                                />
                            </TableRow>
                        </TableFooter>
                    } */}
                </Table>
            </Box>
        );
    }
}

export default BankBalance;